import { render, staticRenderFns } from "./GIHBTXPX.vue?vue&type=template&id=11675c61&scoped=true"
import script from "./GIHBTXPX.vue?vue&type=script&lang=js"
export * from "./GIHBTXPX.vue?vue&type=script&lang=js"
import style0 from "./GIHBTXPX.vue?vue&type=style&index=0&id=11675c61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11675c61",
  null
  
)

export default component.exports